module.exports = __webpack_public_path__ + "static/media/news.c437c694.jpg";